<template>
  <div
    class="p-1"
    style="width: auto"
  >
    <div
      class="mb-1 d-flex justify-content-center saj-header"
    >
      {{ $t("Create Title") }}
    </div>
    <validation-observer ref="simpleRules">

      <b-form>
        <b-form-group
          class="saj-title pt-1 mt-1"
          :label="$t('Title')"
        >
          <validation-provider
            #default="{ errors }"
            :name="$t('Title') "
            rules="required"
          >
            <b-form-input
              v-model="title"
              class="saj-subtitle"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-form>
    </validation-observer>
    <div
      class="d-flex justify-content-center"
      style="
              <!-- background:pink; -->
            "
    >
      <button
        class="btn btn-close m-1 saj-button"
        aria-label="Close modal"
        style="

                color: white;
                background: #ff0000;
              "
        @click="close()"
      >
        {{ $t("Back") }}
      </button>
      <button
        class="btn m-1 saj-button"
        aria-label="submit modal"
        style="

                color: white;
                background: #0b103c !important;
                border-color: #0b103c !important;
              "
        @click="createTitle()"
      >
        {{ $t("Submit") }}
      </button>
    </div>
  </div>
</template>
<script>
import {
  //   BButton,
  //   BModal,
  BForm,
  BFormInput,
  BFormGroup,
  //   BFormTextarea,
  //   BCard,
  //   BFormDatepicker,
  //   BRow,
  //   BCol,
  //   BCalendar,
  //   BCardText,
} from "bootstrap-vue"
// import BCardCode from '@core/components/b-card-code/BCardCode.vue'
// import vSelect from 'vue-select'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import SAJToast from '@/component/saj-toastification.vue'

export default {
  components: {
    // BButton,
    // BModal,
    BForm,
    BFormInput,
    BFormGroup,
    // BFormTextarea,
    // BCard,
    // BFormDatepicker,
    // BCardCode,
    // vSelect,
    // BRow,
    // BCol,
    // BCalendar,
    // BCardText,
    ValidationProvider,
    ValidationObserver,
  },

  data() {
    return {
      title: null,
      required,
    }
  },
  // watch: {
  //   title: {
  //     handler(val){
  //       this.$emit('create-project', val)
  //     },
  //   },
  // },
  mounted() {
  },
  methods: {
    close() {
      this.$emit('close')
    },
    createTitle() {
      this.$refs.simpleRules.validate().then(success => {
        if (success){
          const data = new FormData()
          data.append('title', this.title)
          this.$axios.post(`${this.$baseUrl}/executive/createProjectManagement`, data).then(() => {
            this.$toast(
              {
                component: SAJToast,
                props: {
                  title: `${this.$t(`Successfully saved`)}.`,
                  icon: 'CheckCircleIcon',
                  variant: 'success',
                  titleColor: '#000',
                },
              },
              {
                position: "top-right",
                type: 'info',
              },
            )
            this.$emit('close')
            this.$emit('reload-create', this.title)
          })
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";

.eventtext {
  font-family: "Poppins";
  font-weight: normal;
  font-size: 25px;
  line-height: 30px;
  letter-spacing: 0.4px;
}
</style>
